module.exports = __webpack_public_path__ + "static/cheap-d7218c6ddacc32117d5c3f0330e88714.woff2";